<div [class]="field.styleValue" [attr.lang]="metadataValue.language">
    <span class="text-value">
      {{ value$ | async }}
    </span>
</div>
